import { useIsFetching, useQuery } from '@tanstack/react-query';

export const useFetching = () => {
  const isSessionFetching = useIsFetching({ queryKey: ['highbond-session'] });
  const isUsersMeFetching = useIsFetching({ queryKey: ['users', 'me'] });

  const userRolesQuery = useQuery({ queryKey: ['users', 'roles'] });
  const issueTypeCountQuery = useQuery({ queryKey: ['issue-type-count'] });

  const isUsersRolesFetching =
    userRolesQuery.isLoading && !userRolesQuery.isFetched;
  const isIssueTypeCountFetching =
    issueTypeCountQuery.isLoading && !issueTypeCountQuery.isFetched;

  return (
    Boolean(isSessionFetching + isUsersMeFetching) ||
    isUsersRolesFetching ||
    isIssueTypeCountFetching
  );
};
